<div class="card-header">
  <h6 class="card-title me-auto">Roles</h6>
  <div class="card-options d-flex align-items-center">
    <div class="d-flex">
      @if (hasRolePermission) {
        <div class="clickable-icon">
          <button
            tourAnchor="newRole.anchor"
            [routerLink]="[{ outlets: { modal: 'new' } }]"
            class="btn wre-btn btn-primary"
            type="button"
            [disabled]="!hasRolePermission">
            <i class="far fa-plus me-1 me-md-2"></i>Add
          </button>
        </div>
      }

      <div
        #filterButton
        class="clickable-icon collapsed border-start border-end me-3 ms-3"
        data-bs-toggle="collapse"
        data-bs-target="#filters-container"
        aria-expanded="false">
        <button class="btn btn-icon btn-filter">
          <i class="far fa-filter"></i>
        </button>
      </div>

      <div class="input-group prepend">
        <div class="d-flex">
          <label for="rolesSearchText"></label>
          <input
            tourAnchor="rolesSearch.anchor"
            [(ngModel)]="rolesService.searchTerm"
            [disabled]="(rolesService.roles$ | async)?.length === 0 && !rolesService.isSearchMode"
            class="form-control"
            id="rolesSearchText"
            maxlength="50"
            name="searchTerm"
            autocomplete="off"
            placeholder="Search..." />
          <span class="input-group-text" id="basic-addon2"><i class="far fa-search"></i></span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="border-bottom collapse" id="filters-container">
  <div class="filters">
    <wre-roles-filter-container #filtersContainer (collapseFilterPane)="filterButton.click()">
    </wre-roles-filter-container>
  </div>
</div>

@if (filtersContainer.selectedFilters.length > 0) {
  <div id="filters-selected" class="border-bottom">
    @for (filterItem of filtersContainer.selectedFilters; track filterItem) {
      <button
        (click)="filtersContainer.removeFilter(filterItem)"
        class="badge btn btn-success me-2"
        type="button">
        <span class="pe-2">×</span>
        <span>{{ filterItem.label }}</span>
      </button>
    }
  </div>
}

<div class="card-body">
  <div class="row">
    <div class="col-12">
      @if (loading$ | async) {
        <div class="d-flex justify-content-center">
          <div class="d-flex align-items-center" style="height: 70px">
            <div class="loading"></div>
          </div>
        </div>
      } @else {
        @if (error$ | async) {
          <div class="no-results">Failed to retrieve the roles.</div>
        } @else {
          @if ((rolesService.roles$ | async)?.length === 0) {
            @if (rolesService.isSearchMode) {
              <div class="no-results">
                No items were found based on your search criteria. Please try again.
              </div>
            } @else {
              <div class="no-results">No records to display</div>
            }
          } @else {
            <ng-template [ngTemplateOutlet]="rolesTableBlock"></ng-template>
          }
          @if ((rolesService.roles$ | async)?.length !== 0) {
            <div id="rolesTableBlock">
              <wre-roles-table></wre-roles-table>
              <wre-access-pagination
                [total]="rolesService.total$ | async"
                [(pageSize)]="rolesService.pageSize"
                [(page)]="rolesService.page"></wre-access-pagination>
            </div>
          }
        }
      }
    </div>
  </div>
</div>
<router-outlet name="sidebar"></router-outlet>
<router-outlet name="modal"></router-outlet>
